var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden my-1",attrs:{"title":"Home"}},[_c('svg',{staticClass:"fill-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }